import { render, staticRenderFns } from "./Confluence.vue?vue&type=template&id=1e29a36d&"
import script from "./Confluence.vue?vue&type=script&lang=ts&"
export * from "./Confluence.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports